module.exports = __webpack_public_path__ + "static/media/icn_ui_favourites_active.0d2eb7b0.svg";